export const DATE_ONLY_REQUEST_FORMAT = 'YYYY-MM-DD'

export const PERFORMANCE_KPI_REQUEST_STALE_TIME = 1000 * 60 * 15 // 15 minutes
